/* eslint-disable no-useless-catch */
import { API } from "../api";
import { CITIES_URL } from "../constants/url.constant";

export const GET_CITIES = "GET_CITIES";
export const ADD_CITY = "ADD_CITY";
export const DELETE_CITY = "DELETE_CITY";
export const UPDATE_CITY = "UPDATE_CITY";

export const getCities = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.get(CITIES_URL, {
        params
      });
      if (Object.keys(params).length) {
        dispatch({
          type: GET_CITIES,
          payload: res
        });
      }
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const addCity = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.post(CITIES_URL, data);
      dispatch({
        type: ADD_CITY,
        payload: data
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateCity = (code, body) => {
  return async (dispatch) => {
    try {
      await API.put(`${CITIES_URL}/${code}`, body);
      dispatch({ type: UPDATE_CITY, payload: { code, ...body } });
    } catch (error) {
      throw error;
    }
  };
};

export const removeCity = (cityCode) => {
  return async (dispatch) => {
    try {
      const res = await API.delete(`${CITIES_URL}/${cityCode}`);
      dispatch({
        type: DELETE_CITY,
        payload: cityCode
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export default function reducer(
  state = { cityTableRows: [], totalRows: 0 },
  { type, payload }
) {
  switch (type) {
    case GET_CITIES:
      return {
        ...state,
        cityTableColumns: payload.columns,
        cityTableRows: payload.rows,
        totalRows: payload.count
      };
    case ADD_CITY:
      return {
        ...state,
        totalRows: state.totalRows + 1,
        cityTableRows: [...state.cityTableRows, { ...payload }]
      };
    case DELETE_CITY:
      return {
        ...state,
        totalRows: state.totalRows - 1,
        cityTableRows: state.cityTableRows.filter((hub) => hub.code !== payload)
      };
    case UPDATE_CITY:
      return {
        ...state,
        cityTableRows: state.cityTableRows.map((city) =>
          city.code === payload.code
            ? {
              "hub.region.country.name": city["hub.region.country.name"],
              ...payload
            }
            : city
        )
      };
    default:
      return state;
  }
}
